import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Column, Field, Control, Input, Label } from "rbx";
import {
  EmployeeSelect,
  SystemCodeSelect,
  DateInput
} from "../../../components/inputs";
import { useCurrentUser } from "../../../utils/hooks";
import { useCurrentUserRoles } from "../../../components/Authorization";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {};

function BookingHistoryFilters({ filters, onFilter, onClose }) {
  const { data: UserData } = useCurrentUser();
  const roles = useCurrentUserRoles();

  const [inputs, setInputs] = useState({
    ...filters,
    PickupDate_gte: new Date(filters.PickupDate_gte)
  });

  const handleChange = e => {
    const newFilters = {
      ...inputs
    };
    if (
      e.target.name === "EmployeeRecIdRef" ||
      e.target.name === "BookingCodeCatgRecIdRef"
    ) {
      newFilters[e.target.name] = parseInt(e.target.value);
    } else {
      newFilters[e.target.name] = e.target.value;
    }
    setInputs(newFilters);
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  const EmployeeWhereFilter = {
    Active: true
  };
  if (roles.every(role => role !== "ADMIN")) {
    EmployeeWhereFilter.SupervisorRecIdRef = UserData.EmployeeRecIdRef;
  }

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <EmployeeSelect
              required
              icon="user"
              label="Employee"
              name="EmployeeRecIdRef"
              value={inputs.EmployeeRecIdRef}
              variables={{
                where: {
                  ...EmployeeWhereFilter
                },
                orderByMulti: ["LastName_ASC"]
              }}
              onChange={handleChange}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <Control expanded>
              <SystemCodeSelect
                icon="book-open"
                label="Booking Category"
                name="BookingCodeCatgRecIdRef"
                value={inputs.BookingCodeCatgRecIdRef}
                where={{
                  Category: "BookingCodes",
                  CodeName: "BookCatg",
                  CodeId_startsWith: "NA"
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Booking Code</Label>
              <Input
                expanded
                autocomplete="new"
                name="BookingCode_contains"
                type="text"
                value={inputs?.BookingCode_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Control>
            <Label>Start Date</Label>
            <DateInput
              name="PickupDate_gte"
              value={
                inputs.PickupDate_gte
                  ? moment(inputs.PickupDate_gte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>End Date</Label>
            <DateInput
              name="PickupDate_lte"
              value={
                inputs.PickupDate_lte
                  ? moment(inputs.PickupDate_lte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
BookingHistoryFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default BookingHistoryFilters;
